/* eslint-disable no-alert */
import { router } from "@inertiajs/react";
import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import faUp from "icons/regular/up.svg";
import faUpSolid from "icons/solid/up.svg";
import { useMutation } from "lib/apollo/client";
import classNames from "lib/classNames";
import { createPromptAnswer, CreatePromptAnswerType } from "queries/prompts/createPromptAnswer";
import { deletePromptAnswer } from "queries/prompts/deletePromptAnswer";
import { useState } from "react";
import { usePromptAnswer } from "store/currentUser/currentUserSelector";
import { PromptSerializersPromptBook } from "types/serializers";

export interface Props {
  promptBook: PromptSerializersPromptBook;
}
export interface PromptBookCurrentUserProps {
  promptBook: PromptSerializersPromptBook;
  answersCount: number;
}

export default function PromptBookCurrentUser({
  answersCount,
  promptBook,
}: PromptBookCurrentUserProps) {
  const currentUserId = useCurrentUserId();
  const initialPromptAnswerId = usePromptAnswer(promptBook);

  // const username = useCurrentUser((u) => u.username);
  const [answerId, setAnswerId] = useState(initialPromptAnswerId);
  const [sendUpvote, { loading: insertLoading }] = useMutation<CreatePromptAnswerType>(createPromptAnswer);

  const [sendRemoveVote, { loading: deleteLoading }] = useMutation(deletePromptAnswer);
  const [currentAnswersCount, setCurrentAnswersCount] = useState(answersCount);

  const removeVote = () => {
    sendRemoveVote({
      variables: {
        id: answerId,
      },
    })
      .then((result) => {
        setAnswerId(null);
        setCurrentAnswersCount(
          result.data.promptAnswer.promptBook.answersCount
        );
      })
      .catch(() => {
        setCurrentAnswersCount(currentAnswersCount - 1);
      });
  };

  const vote = () => {
    sendUpvote({
      variables: {
        promptId: promptBook.promptId,
        bookId: promptBook.bookId,
      },
    })
      .then((result) => {
        const { promptAnswer } = result.data.insertResult;
        setAnswerId(promptAnswer.id);
        setCurrentAnswersCount(promptAnswer.promptBook.answersCount);
      })
      .catch(() => {
        setCurrentAnswersCount(currentAnswersCount + 1);
      });
  };

  const toggleVote = (e) => {
    e.preventDefault();
    if (!currentUserId) {
      router.visit(`/join`);
    } else if (answerId) {
      removeVote();
    } else {
      vote();
    }
  };

  return (
    <Button
      className={classNames(
        "flex flex-col items-center group hover:text-indigo-500 dark:hover:text-yellow-400 p-2 pt-2 border-2 rounded-sm border-transparent dark:hover:border-yellow-400 hover:border-indigo-500 font-bold",
        answerId ? "text-indigo-500 dark:text-yellow-400" : ""
      )}
      onClick={toggleVote}
    >
      <Icon icon={answerId ? faUpSolid : faUp} size="2xl" />
      {insertLoading || deleteLoading ? (
        <LoadingSpinner size="md" variant="none" />
      ) : (
        <>{currentAnswersCount.toLocaleString()}</>
      )}
    </Button>
  );
}
